import './_gtw-main-tab.sass';

import $ from 'jquery';

import Class from '../../legacy-class';

import '../../../../../mui/tumbler';

import {BottomTab} from '../../bottom-tab';
import gtw_open_temporary_dialog from './gtw-temporary-dialog';
import {gtw_mode_names, parse_gtw_fails} from './gtw-state-tab';
import VisibilityManager from '../../visibility-manager';
import {escape_html, rusTimeDate} from '../../../../../utils';

const temporary_modes = ['workday', 'weekend', 'econom', 'party'];

export const GTWMainTab = Class(BottomTab, {
    init(_ui) {
        this._ui = _ui;
        const v84_v116_filter = [
            'device.firmware_version()',
            'device.firmware_version()[1] >= 84',

            'device.gtw_boiler_version()',
            'device.gtw_boiler_version().sw_version',
            'device.gtw_boiler_version().sw_version[0] >= 1',
            'device.gtw_boiler_version().sw_version[1] >= 16',
        ].join(' && ');

        this._element = $(
            `
            <div class="ui-bottom-tab ui-gtw-main-tab"
                tabtitle="режимы" tabicon="ui-icon-tab-temperature" role="gtw-main">
               
                <div class="ui-cards-container">
                    <div class="ui-card ui-thermostat-control-tab-offline">
                        <h1>Нет связи</h1>
                    </div>
                </div>
                <div class="ui-cards-container">
                    <div class="ui-card ui-thermostat-control-tab-fault">
                        <h1>АВАРИЯ КОТЛА</h1>
                        <div class="ui-thermostat-control-tab-fault-details"></div>
                    </div>
                </div>
               
                <div class="ui-cards-container">
                    <div class="ui-gtw-main-tab-wide-card ui-card">
                        <h1>Режим работы</h1>
                       
                        <div class="ui-gtw-main-tab-modes">
                            <div class="ui-gtw-main-tab-mode" mode="week">
                                <div class="ui-thermostat-control-mode-title">Недельный</div>
                                <div class="ui-thermostat-control-mode-temp" role="week_temp"></div>
                            </div>
                            <div class="ui-gtw-main-tab-mode" mode="air">
                                <div class="ui-thermostat-control-mode-title">Комнатный</div>
                                <div class="ui-thermostat-control-mode-temp" role="gtw_t_air"></div>
                                <div class="ui-thermostat-control-mode-dec">–</div>
                                <div class="ui-thermostat-control-mode-inc">+</div>
                            </div>
                            <div class="ui-gtw-main-tab-mode" mode="water">
                                <div class="ui-thermostat-control-mode-title">Водонагрев</div>
                                <div class="ui-thermostat-control-mode-temp" role="gtw_t_water">&nbsp;</div>
                                <div class="ui-thermostat-control-mode-dec">–</div>
                                <div class="ui-thermostat-control-mode-inc">+</div>
                            </div>
                            <div class="ui-gtw-main-tab-mode" mode="floor">
                                <div class="ui-thermostat-control-mode-title">Тёплый пол</div>
                                <div class="ui-thermostat-control-mode-temp" role="floor_target_temp">&nbsp;</div>
                                <div class="ui-thermostat-control-mode-dec">–</div>
                                <div class="ui-thermostat-control-mode-inc">+</div>
                            </div>
                            <div class="ui-gtw-main-tab-mode" mode="temporary">
                                <div class="ui-thermostat-control-mode-title">Временный</div>
                                <div class="ui-thermostat-control-mode-temp" role="temporary_temp">42</div>
                                <div class="ui-gtw-main-tab-mode-until" role="temporary-until"></div>
                                <div class="ui-thermostat-control-mode-dec">–</div>
                                <div class="ui-thermostat-control-mode-inc">+</div>
                            </div>
                            <div class="ui-gtw-main-tab-mode full-off" mode="off">
                                <div class="ui-thermostat-control-mode-title">Выключен</div>
                                <div class="ui-thermostat-control-mode-off">Регулирование отключено</div>
                            </div>
                        </div>
               
                        <div class="ui-gtw-main-tab-dhw">
                            <div class="ui-gtw-main-tab-dhw-tumbler"></div>
                        </div>
               
                        <div class="ui-gtw-main-tab-dhw" show-if="` +
                v84_v116_filter +
                `">
                            <div class="ui-gtw-main-tab-thermostat-tumbler"></div>
                        </div>
                    </div>
                </div>
               
                <div class="ui-cards-container">
                    <div class="ui-gtw-main-tab-narrow-card ui-card">
                        <h1>Температура воды</h1>
               
                        <div class="ui-thermometers-view-therm" temperature-name="gtw_t_water_sensor">
                            <div class="ui-thermometers-view-therm-title">
                                <div class="ui-thermometers-view-therm-title-text">фактическая</div>
                            </div>
                            <div class="ui-thermometers-view-therm-value" style="border-color: #0070b7"></div>
                        </div>
                        <div class="ui-thermometers-view-therm" temperature-name="gtw_t_water_set_disp">
                            <div class="ui-thermometers-view-therm-title">
                                <div class="ui-thermometers-view-therm-title-text">заданная</div>
                            </div>
                            <div class="ui-thermometers-view-therm-value" style="border-color: #0070b7"></div>
                        </div>
                        <!-- FIXME: hijacking ThermometersView font auto-resizing -->
                        <div class="ui-thermometers-view-therm" style="display: none"></div>
                    </div>
                    <div class="ui-gtw-main-tab-narrow-card ui-card">
                        <h1>Комнатная температура</h1>
               
                        <div class="ui-thermometers-view-therm" temperature-name="gtw_t_air_int_sensor">
                            <div class="ui-thermometers-view-therm-title">
                                <div class="ui-thermometers-view-therm-title-text">фактическая</div>
                            </div>
                            <div class="ui-thermometers-view-therm-value" style="border-color: #f0662f"></div>
                        </div>
                        <div class="ui-thermometers-view-therm" temperature-name="gtw_t_air_set_disp">
                            <div class="ui-thermometers-view-therm-title">
                                <div class="ui-thermometers-view-therm-title-text">заданная</div>
                            </div>
                            <div class="ui-thermometers-view-therm-value" style="border-color: #f0662f"></div>
                        </div>
                        <!-- FIXME: hijacking ThermometersView font auto-resizing -->
                        <div class="ui-thermometers-view-therm" style="display: none"></div>
                    </div>
                </div>
            </div>
        `
        );

        this._bound_handlers = {};
        for (const [prop, handler] of Object.entries(this._handlers ?? {}))
            this._bound_handlers[prop] = handler.bind(this);

        this._element.on('click', '.ui-gtw-main-tab-mode', (ev) =>
            this._on_mode_click($(ev.currentTarget).attr('mode'))
        );

        this._element
            .find('.ui-gtw-main-tab-mode')
            .on('click', '.ui-thermostat-control-mode-dec', (ev) =>
                this._on_dec_inc(ev, -1)
            )
            .on('click', '.ui-thermostat-control-mode-inc', (ev) =>
                this._on_dec_inc(ev, +1)
            );

        const on_schedule_temp_update_timeout = () => {
            if (this._device) this._update_schedule_temp();
            return reschedule_schedule_temp_update();
        };
        const every = 60 * 60 * 1e3;
        var reschedule_schedule_temp_update = () => {
            // +1s to be sure we are in a next hour
            setTimeout(
                () => on_schedule_temp_update_timeout(),
                every - (Date.now() % every) + 1e3
            );
        };
        reschedule_schedule_temp_update();

        const dhw_tumbler = this._element.find('.ui-gtw-main-tab-dhw-tumbler');
        dhw_tumbler.tumbler({
            text: {
                off: 'Режим ГВС',
                on: 'Режим ГВС',
            },

            change: (event, {from_ui, checked}) => {
                if (from_ui) {
                    const updater = {
                        gtw_gvs: checked,
                        gtw_heat: {current: true, old: true},
                    };
                    this._device?.updateSettings(updater, null, {
                        ignore_server_response: true,
                        obey_only_last_response: true,
                    });
                }
            },
        });

        const thermostat_tumbler = this._element.find(
            '.ui-gtw-main-tab-thermostat-tumbler'
        );
        thermostat_tumbler.tumbler({
            text: {
                off: 'Термостат',
                on: 'Термостат',
            },

            change: (event, {from_ui, checked}) => {
                if (from_ui) {
                    const updater = {gtw_thermostat_set: checked};
                    this._device?.updateSettings(updater, null, {
                        ignore_server_response: true,
                        obey_only_last_response: true,
                    });
                }
            },
        });

        this._visibility_manager = new VisibilityManager(this._element);

        // redux
        this._ui.store.subscribe(() => {
            const selected_id = this._ui.store.getState().devices.selected_id;
            const device = this._ui.store
                .getState()
                .devices.items.find((device) => device.id === selected_id);

            // online
            this._element
                .find('.ui-thermostat-control-tab-offline')
                .toggleClass('visible', !device.online);

            // gtw_fail
            const fail_texts = parse_gtw_fails(device.gtw_fail);
            this._element
                .find('.ui-thermostat-control-tab-fault-details')
                .html(fail_texts.map((text) => `<p>${escape_html(text)}</p>`).join(''));
            this._element
                .find('.ui-thermostat-control-tab-fault')
                .toggleClass('visible', fail_texts.length > 0);

            //gtw_mode
            const mode = device?.gtw_mode;
            if (mode == null) return;

            //            active_button = switch
            //                when mode.current in temporary_modes then 'temporary'
            //                when mode.current == 'week' then 'with-schedule'
            //                else 'without-schedule'

            const active_button = temporary_modes.includes(mode.current)
                ? 'temporary'
                : mode.current;

            this._element
                .find(`[mode=\"${active_button}\"]`)
                .addClass('selected')
                .siblings()
                .removeClass('selected');

            this._element
                .find('[mode="temporary"]')
                .find('.ui-thermostat-control-mode-title')
                .text(
                    active_button === 'temporary'
                        ? gtw_mode_names[mode.current]
                        : 'Временный'
                )
                .end();
            this._update_temporary_temp_redux(device);

            //gtw_temporary_end
            const t = device.gtw_temporary_end;
            this._element
                .find('[role="temporary-until"]')
                .text(
                    t != null
                        ? `до ${rusTimeDate(
                              new Date(
                                  t.year,
                                  t.month - 1,
                                  t.day,
                                  t.hour,
                                  t.minute,
                                  0,
                                  0
                              )
                          )}`
                        : ''
                );

            //gtw_t_air_int_sensor
            this._show_temperature_redux('gtw_t_air_int_sensor', device);

            //gtw_t_water_sensor
            this._show_temperature_redux('gtw_t_water_sensor', device);

            //gtw_t_air_set_disp
            this._show_temperature_redux('gtw_t_air_set_disp', device);

            //gtw_t_water_set_disp
            this._show_temperature_redux('gtw_t_water_set_disp', device);

            //gtw_t_air
            this._show_temperature_by_role_redux('gtw_t_air', device);

            if (this.is_new_floor_alg_redux(device))
                this._role('floor_target_temp').html(
                    this._format_temp_html(device.gtw_t_air)
                );

            // gtw_t_water
            this._show_temperature_by_role_redux('gtw_t_water', device);

            if (!this.is_new_floor_alg_redux(device)) {
                const floor_target_temp = Math.min(45, device.gtw_t_water);
                this._role('floor_target_temp').html(
                    this._format_temp_html(floor_target_temp)
                );
            }

            //timezone
            //gtw_workday_schedule
            //gtw_weekend_schedule
            this._update_schedule_temp_redux(device);

            //gtw_t_air_econom
            //gtw_t_air_comfort
            this._update_temporary_temp_redux(device);

            //gtw_gvs
            this._element
                .find('.ui-gtw-main-tab-dhw-tumbler')
                .tumbler('checked', device.gtw_gvs);

            //gtw_thermostat_set
            this._element
                .find('.ui-gtw-main-tab-thermostat-tumbler')
                .tumbler('checked', device.gtw_thermostat_set);
        });
    },

    should_appear(device) {
        return (
            device?.has_access('view_state') &&
            device?.has_capability('has_gtw_reports')
        );
    },

    is_new_floor_alg(device) {
        return (
            device.firmware_version()?.[1] >= 84 &&
            device.gtw_boiler_version()?.sw_version?.[0] >= 1 &&
            device.gtw_boiler_version()?.sw_version?.[1] >= 16
        );
    },

    is_new_floor_alg_redux(device) {
        return (
            device.firmware_version?.[1] >= 84 &&
            device.gtw_boiler_version?.sw_version?.[0] >= 1 &&
            device.gtw_boiler_version?.sw_version?.[1] >= 16
        );
    },

    _handlers: {
        online() {
            this._element
                .find('.ui-thermostat-control-tab-offline')
                .toggleClass('visible', !this._device.online());
        },

        gtw_fail() {
            const fail_texts = parse_gtw_fails(this._device.gtw_fail());
            this._element
                .find('.ui-thermostat-control-tab-fault-details')
                .html(fail_texts.map((text) => `<p>${escape_html(text)}</p>`).join(''));
            this._element
                .find('.ui-thermostat-control-tab-fault')
                .toggleClass('visible', fail_texts.length > 0);
        },

        gtw_mode() {
            const mode = this._device?.gtw_mode();
            if (mode == null) return;

            //            active_button = switch
            //                when mode.current in temporary_modes then 'temporary'
            //                when mode.current == 'week' then 'with-schedule'
            //                else 'without-schedule'

            const active_button = temporary_modes.includes(mode.current)
                ? 'temporary'
                : mode.current;

            this._element
                .find(`[mode=\"${active_button}\"]`)
                .addClass('selected')
                .siblings()
                .removeClass('selected');

            this._element
                .find('[mode="temporary"]')
                .find('.ui-thermostat-control-mode-title')
                .text(
                    active_button === 'temporary'
                        ? gtw_mode_names[mode.current]
                        : 'Временный'
                )
                .end();
            this._update_temporary_temp();
        },

        gtw_temporary_end() {
            const t = this._device.gtw_temporary_end();
            this._element
                .find('[role="temporary-until"]')
                .text(
                    t != null
                        ? `до ${rusTimeDate(
                              new Date(
                                  t.year,
                                  t.month - 1,
                                  t.day,
                                  t.hour,
                                  t.minute,
                                  0,
                                  0
                              )
                          )}`
                        : ''
                );
        },

        gtw_t_air_int_sensor() {
            this._show_temperature('gtw_t_air_int_sensor');
        },
        gtw_t_water_sensor() {
            this._show_temperature('gtw_t_water_sensor');
        },
        gtw_t_air_set_disp() {
            this._show_temperature('gtw_t_air_set_disp');
        },
        gtw_t_water_set_disp() {
            this._show_temperature('gtw_t_water_set_disp');
        },

        gtw_t_air() {
            this._show_temperature_by_role('gtw_t_air');

            if (this.is_new_floor_alg(this._device))
                this._role('floor_target_temp').html(
                    this._format_temp_html(this._device.gtw_t_air())
                );
        },

        gtw_t_water() {
            this._show_temperature_by_role('gtw_t_water');

            if (!this.is_new_floor_alg(this._device)) {
                const floor_target_temp = Math.min(45, this._device.gtw_t_water());
                this._role('floor_target_temp').html(
                    this._format_temp_html(floor_target_temp)
                );
            }
        },

        timezone() {
            this._update_schedule_temp();
        },
        gtw_workday_schedule() {
            this._update_schedule_temp();
        },
        gtw_weekend_schedule() {
            this._update_schedule_temp();
        },

        gtw_t_air_econom() {
            this._update_temporary_temp();
        },
        gtw_t_air_comfort() {
            this._update_temporary_temp();
        },

        gtw_gvs() {
            return this._element
                .find('.ui-gtw-main-tab-dhw-tumbler')
                .tumbler('checked', this._device.gtw_gvs());
        },

        gtw_thermostat_set() {
            return this._element
                .find('.ui-gtw-main-tab-thermostat-tumbler')
                .tumbler('checked', this._device.gtw_thermostat_set());
        },
    },

    _format_temp_html(temp) {
        if (temp != null) return `${parseInt(temp, 10)} °C`;
        else return '&nbsp;';
    },
    _role(role) {
        return this._element.find(`[role=\"${role}\"]`);
    },

    _show_temperature(temp_name) {
        const value = this._device[temp_name]();
        this._element
            .find(
                `[temperature-name=\"${temp_name}\"] .ui-thermometers-view-therm-value`
            )
            .text(value != null ? `${parseInt(value, 10)} °C` : 'нет данных');
    },

    _show_temperature_redux(temp_name, device) {
        const value = device[temp_name];
        this._element
            .find(
                `[temperature-name=\"${temp_name}\"] .ui-thermometers-view-therm-value`
            )
            .text(value != null ? `${parseInt(value, 10)} °C` : 'нет данных');
    },

    _show_temperature_by_role(prop_name) {
        const value = this._device[prop_name]();
        this._role(prop_name).html(
            value != null ? `${parseInt(value, 10)} °C` : '&nbsp;'
        );
    },

    _show_temperature_by_role_redux(prop_name, device) {
        const value = device?.[prop_name];
        this._role(prop_name).html(
            value != null ? `${parseInt(value, 10)} °C` : '&nbsp;'
        );
    },

    _on_mode_click(active_button) {
        if (this._device == null) return;

        let updater_dfr = $.Deferred();
        if (active_button === 'temporary')
            updater_dfr = gtw_open_temporary_dialog(this._ui, this._device);
        else if (active_button === 'floor' && !this.is_new_floor_alg(this._device)) {
            if (this._device.gtw_mode().current !== 'floor') {
                updater_dfr.resolve({
                    gtw_t_water: Math.min(45, this._device.gtw_t_water()),
                    gtw_mode: {
                        current: 'floor',
                        old: 'floor',
                    },
                });
            }
        } else {
            if (this._device.gtw_mode().current !== active_button)
                updater_dfr.resolve({
                    gtw_mode: {current: active_button, old: active_button},
                });
        }

        updater_dfr?.done((updater) => {
            const heat = active_button !== 'off';
            updater.gtw_heat = {current: heat, old: heat};
            this._device.set(updater);
            this._device.updateSettings(updater, null, {
                ignore_server_response: true,
                obey_only_last_response: true,
            });
        });
    },

    _current_schedule_temp(schedule_type, browser_time = new Date()) {
        const tz = this._device.timezone() ?? 3;
        const device_time = new Date(
            browser_time.getTime() +
                browser_time.getTimezoneOffset() * 60 * 1e3 +
                tz * 60 * 60 * 1e3
        );
        const day = (device_time.getDay() + 6) % 7;
        const weekend = day >= 5;
        const hour = device_time.getHours();

        let schedule;
        switch (schedule_type) {
            case 'week':
                if (weekend) schedule = this._device.gtw_weekend_schedule();
                else schedule = this._device.gtw_workday_schedule();
                break;
            case 'workday':
                schedule = this._device.gtw_workday_schedule();
                break;
            case 'weekend':
                schedule = this._device.gtw_weekend_schedule();
                break;
            default:
                throw 'schedule_type should be "week", "workday" or "weekend"';
        }

        if (schedule == null) return null;

        switch (schedule[hour]) {
            case 'M1':
                return this._device.gtw_t_air_comfort();
            case 'M2':
                return this._device.gtw_t_air_econom();
            case 'M3':
                return null;
            default:
                return schedule[hour];
        }
    },

    _current_schedule_temp_redux(schedule_type, device, browser_time = new Date()) {
        const tz = device.timezone ?? 3;
        const device_time = new Date(
            browser_time.getTime() +
                browser_time.getTimezoneOffset() * 60 * 1e3 +
                tz * 60 * 60 * 1e3
        );
        const day = (device_time.getDay() + 6) % 7;
        const weekend = day >= 5;
        const hour = device_time.getHours();

        let schedule;
        switch (schedule_type) {
            case 'week':
                if (weekend) schedule = device.gtw_weekend_schedule;
                else schedule = device.gtw_workday_schedule;
                break;
            case 'workday':
                schedule = device.gtw_workday_schedule;
                break;
            case 'weekend':
                schedule = device.gtw_weekend_schedule;
                break;
            default:
                throw 'schedule_type should be "week", "workday" or "weekend"';
        }

        if (schedule == null) return null;

        switch (schedule[hour]) {
            case 'M1':
                return device.gtw_t_air_comfort;
            case 'M2':
                return device.gtw_t_air_econom;
            case 'M3':
                return null;
            default:
                return schedule[hour];
        }
    },

    _update_schedule_temp() {
        this._role('week_temp').html(
            this._format_temp_html(this._current_schedule_temp('week'))
        );
        this._update_temporary_temp();
    },

    _update_schedule_temp_redux(device) {
        this._role('week_temp').html(
            this._format_temp_html(this._current_schedule_temp_redux('week', device))
        );
        this._update_temporary_temp_redux(device);
    },

    _update_temporary_temp_redux(device) {
        let html;
        switch (device.gtw_mode?.current) {
            case 'econom':
                html = this._format_temp_html(this._device.gtw_t_air_econom());
                break;
            case 'party':
                html = this._format_temp_html(this._device.gtw_t_air_comfort());
                break;
            case 'workday':
            case 'weekend': {
                const temp = this._current_schedule_temp(device.gtw_mode.current);
                html = temp != null ? this._format_temp_html(temp) : 'отключен';

                break;
            }
            default:
                html = '&nbsp;';
        }
        this._role('temporary_temp').html(html);
    },

    _update_temporary_temp() {
        let html;
        switch (this._device.gtw_mode()?.current) {
            case 'econom':
                html = this._format_temp_html(this._device.gtw_t_air_econom());
                break;
            case 'party':
                html = this._format_temp_html(this._device.gtw_t_air_comfort());
                break;
            case 'workday':
            case 'weekend':
                const temp = this._current_schedule_temp(
                    this._device.gtw_mode().current
                );
                html = temp != null ? this._format_temp_html(temp) : 'отключен';
                break;
            default:
                html = '&nbsp;';
        }
        this._role('temporary_temp').html(html);
    },

    _on_dec_inc(event, delta) {
        const mode = $(event.currentTarget)
            .closest('.ui-gtw-main-tab-mode')
            .attr('mode');

        const device = this.device();
        if (device == null) return;

        let updater = null;
        if (mode === 'air' || (mode === 'floor' && this.is_new_floor_alg(this._device)))
            updater = {
                gtw_t_air: Math.max(10, Math.min(35, device.gtw_t_air() + delta)),
            };
        else if (mode === 'floor' && !this.is_new_floor_alg(this._device))
            updater = {
                gtw_t_water: Math.max(10, Math.min(45, device.gtw_t_water() + delta)),
            };
        else if (mode === 'water')
            updater = {
                gtw_t_water: Math.max(10, Math.min(85, device.gtw_t_water() + delta)),
            };
        else if (mode === 'temporary') {
            switch (device.gtw_mode().current) {
                case 'econom':
                    event.stopPropagation();
                    updater = {
                        gtw_t_air_econom: Math.max(
                            10,
                            Math.min(35, device.gtw_t_air_econom() + delta)
                        ),
                    };
                    break;
                case 'party':
                    event.stopPropagation();
                    updater = {
                        gtw_t_air_comfort: Math.max(
                            10,
                            Math.min(35, device.gtw_t_air_comfort() + delta)
                        ),
                    };
                    break;
            }
        }

        if (updater != null) {
            device.set(updater);
            device.updateSettings(updater, () => {}, {
                ignore_server_response: true,
                obey_only_last_response: true,
            });
        }
    },
}).implement(
    Class.Properties({
        device: {
            set(device) {
                this._device_bindings?.unbind();
                this._device_bindings = null;

                this._device = device;
                if (this._device != null) {
                    this._device_bindings = this._device.bind(this._bound_handlers);

                    for (const handler of Object.values(this._handlers ?? {}))
                        handler.apply(this);
                }

                this._visibility_manager.device(device);
            },
        },
    })
);

GTWMainTab.should_appear = GTWMainTab.prototype.should_appear;
